import { render, staticRenderFns } from "./FormStructure.vue?vue&type=template&id=43aad4dc"
import script from "./FormStructure.vue?vue&type=script&lang=js"
export * from "./FormStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports